import "core-js/modules/es.array.push.js";
import Responsive from '@/services/browser/Responsive';
import Util from '@/services/browser/Util';
import Footer from '@/components/microsites/Footer.vue';
import '@/assets/scss/microsites/legacy/override/styles.css';
export default {
  name: 'Override',
  components: {
    Footer
  },
  data() {
    return {
      loading: true
    };
  },
  mounted() {
    Responsive.init();
    this.onWindowResize();
    window.addEventListener('resize', this.onWindowResize);
    setTimeout(() => {
      this.loading = false;
      window.dataLayer.push({
        pageType: 'Microsite',
        micrositeName: 'Override',
        micrositePhase: '1'
      });
    }, 210);
  },
  unmounted() {
    window.removeEventListener('resize', this.onWindowResize);
  },
  methods: {
    playFree() {
      Util.playFree();
    },
    onWindowResize() {
      let window_w = document.body.clientWidth;
      let fs = 16,
        fontMax_WindowWidth = 1920,
        font_size;
      if (window.matchMedia('(max-width: 639px)').matches) {
        font_size = fs * window_w / 640;
      } else if (window.matchMedia('(max-width: 1023px)').matches) {
        font_size = fs * window_w / 1024;
      } else if (window.matchMedia('(max-width: 1439px)').matches) {
        font_size = fs * window_w / 1440;
      } else {
        font_size = fs * window_w / fontMax_WindowWidth;
      }
      document.body.style.fontSize = font_size + 'px';
    }
  }
};